import React, { ReactElement } from "react";
import { Navigation } from "../../components";
import Footer from "../../components/footer/Footer";
import { CreateTicketProvider } from "../../contexts/CreateTicketContext";
import { KeyboardShortcutProvider } from "../../contexts/KeyboardShortcutContext";
import { NotificationProvider } from "../../contexts/NotificationContext";
import { PortalProvider } from "../../contexts/PortalContext";
import { PortalSubscriptionProvider } from "../../contexts/PortalSubscriptionContext";
import { UpdatesProvider } from "../../contexts/updates/UpdatesContext";
import { AuthProvider } from "../../contexts/UserContext";
import Routes from "../../Routes";
import { ErrorDefault } from "../error/Error";
import "./App.css";
import { LoggingProvider, LoggingHandler, createContextData } from "../../contexts/logging/LoggingContext";

interface State {
    error?: Error
}
export default class App extends React.Component<unknown, State> {
    private handleRejection: (event: PromiseRejectionEvent) => void;

    private handleError: (event: ErrorEvent) => void;

    constructor(props: unknown) {
        super(props);
        this.state = { };
        this.handleRejection = event => {
            LoggingHandler.instance.error(event.reason as Error, createContextData("error-handler"), "Uncaught promise");
            event.preventDefault();
        };
        this.handleError = event => {
            const error = typeof event === "string" ? new Error(event) : event.error;
            LoggingHandler.instance.error(error, createContextData("error-handler"), "Uncaught error");
            event.preventDefault();
        };
    }

    componentDidMount(): void {
        window.addEventListener("unhandledrejection", this.handleRejection);
        window.addEventListener("error", this.handleError);
    }

    componentDidCatch(error: Error): void {
        LoggingHandler.instance.error(error, createContextData("error-handler"), "Uncaught react error");
        this.setState({ error });
    }

    componentWillUnmount(): void {
        window.removeEventListener("unhandledrejection", this.handleRejection);
        window.removeEventListener("error", this.handleError);
    }

    static getDerivedStateFromError(error: Error): State {
        return { error };
    }

    render(): ReactElement {
        return (
            <div className="app d-flex flex-column">
                <LoggingProvider>
                    {this.state.error ? (
                        <>
                            <Navigation />
                            <ErrorDefault message={this.state.error.message} stacktrace={this.state.error.stack?.split("\n")} />
                        </>
                    ) : (

                        <PortalProvider>
                            <AuthProvider>
                                <KeyboardShortcutProvider>
                                    <NotificationProvider>
                                        <PortalSubscriptionProvider>
                                            <CreateTicketProvider>
                                                <UpdatesProvider>
                                                    <>
                                                        <Navigation />
                                                        <div className="flex-grow-1">
                                                            <Routes />
                                                        </div>
                                                    </>
                                                </UpdatesProvider>
                                            </CreateTicketProvider>
                                        </PortalSubscriptionProvider>
                                    </NotificationProvider>
                                </KeyboardShortcutProvider>
                            </AuthProvider>
                        </PortalProvider>

                    )}
                </LoggingProvider>
                <Footer />
            </div>
        );
    }
}
